import React, { useState } from 'react'
import {
    Button,
    Container,
    Stack,
    Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { t } from 'i18next';
import Iconify from '../../components/Iconify';
import Page from '../../components/Page';
import { NoteService } from '../../Services/note.service';
import NotesCard from '../../sections/@dashboard/notes/NotesCard';

const NotesPage = () => {
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar();
    const [note, setNote] = useState([]);

    React.useEffect(() => {
        GetNote()
    }, []);

    const GetNote = async () => {
        const noteData = await NoteService.GetNote();
        setNote(noteData);
    };

    const handleEditNote = React.useCallback((_id) => navigate(`/notes/${_id}`), []);

    const handleDeleteNote = React.useCallback(
        (id) =>
            Swal.fire({
                customClass: {
                    container: { zIndex: 999999 },
                },
                title: 'Xóa quảng cáo',
                text: 'Thao tác này không thể hoàn tác',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: t('sure.yes'),
                cancelButtonText: t('sure.no'),
            }).then((result) => {
                if (result.isConfirmed) {
                    NoteService.DeleteNote(id)
                        .then(() => {
                            const newData = note.filter((notee) => notee._id !== id);
                            setNote(newData);
                            enqueueSnackbar('Thành công', { variant: 'success' });
                        })
                        .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
                }
            }),
        [note]
    );

    return (
        <Page title={'Notes'}>
            <Container maxWidth="lg">
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Notes
                    </Typography>
                    <Button
                        variant="contained"
                        component={RouterLink}
                        to="/notes/create"
                        startIcon={<Iconify icon="eva:plus-fill" />}
                    >
                        Thêm note
                    </Button>
                </Stack>

                {note.map((notee) => (
                    <NotesCard
                        key={notee._id}
                        notee={notee}
                        onEdit={handleEditNote}
                        onDelete={handleDeleteNote}
                    />
                ))}
            </Container>
        </Page>
    )
}

export default NotesPage